import { useEffect, useState } from "react";
import classNames from "classnames";
import CloseIcon from "./CloseIcon";

const MainPopup = ({
  children,
  title = "",
  withHeader = true,
  withAnimate = true,
  classnames = {},
  onClose,
}) => {
  const [isOpen, setIsOpen] = useState(true);
  const [isAnimating, setIsAnimating] = useState(!withAnimate);

  useEffect(() => {
    if (isOpen && withAnimate) {
      setTimeout(() => setIsAnimating(true), 0); // Запуск анимации
    } else {
    }
  }, [isOpen]);

  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  const closedOverlayHandler = (e) => {
    if (e.target.classList.contains("overlay")) {
      closedHandler();
    }
    if (e) {
      e.stopPropagation();
    }
  };

  const closedHandler = (e) => {
    if (withAnimate) {
      setIsAnimating(false);
    }
    setTimeout(() => onClose(e), 300);
  };

  return (
    <div className="overlay" onClick={closedOverlayHandler}>
      <div
        className={classNames("popup beautyScroll", {
          noHeader: !withHeader,
          open: isAnimating,
          ...classnames,
        })}
      >
        {withHeader && (
          <div className={classNames("popup__header", { empty: !title })}>
            {title && <h3>{title}</h3>}
            <span className="closeBtn" onClick={closedHandler}>
              <CloseIcon w={20} h={20} />
            </span>
          </div>
        )}
        <div className="popup__content">{children}</div>
      </div>
    </div>
  );
};

export default MainPopup;
